// File: src/components/Footer.jsx
import React from 'react';
import { Mail } from 'lucide-react';

const Footer = React.memo(() => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-6 lg:px-8 py-6">
        <div className="flex flex-col items-center space-y-2">
          {/* Logo and Brand - tighter spacing */}
          <div className="text-center">
            <div className="text-xl font-bold text-sws-navy">
              Profit Clarity
            </div>
            <div className="text-xs text-sws-lavender">
              by Scaling with Strategy
            </div>
          </div>
          
          {/* Links - reduced spacing */}
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <a 
              href="/terms"
              className="text-sws-slate hover:text-sws-purple transition-colors cursor-pointer"
            >
              Terms of Service
            </a>
            <a 
              href="/privacy"
              className="text-sws-slate hover:text-sws-purple transition-colors cursor-pointer"
            >
              Privacy Policy
            </a>
            <a 
              href="mailto:support@getprofitclarity.com" 
              className="text-sws-slate hover:text-sws-purple transition-colors inline-flex items-center gap-1"
            >
              <Mail size={14} />
              Contact Support
            </a>
          </div>
          
          {/* Copyright - tight to links */}
          <div className="text-xs text-sws-slate text-center">
            © {currentYear} Scaling with Strategy. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;